import React from 'react';

import Calculators from 'sharedComponents/AffordabilityCalculator';
import useStyles from './useStyles';

const EmbedLayout = () => {
  const classes = useStyles();

  return (
    <div className={classes.paper}>
      <main className={classes.content}>
        <Calculators />
      </main>
    </div>
  );
};

export default EmbedLayout;



// WEBPACK FOOTER //
// ./src/components/EmbedCalculator/EmbedCalculator.js